import {
  Button,
  CrossIcon,
  useToastContext,
} from '@trufla-technology/trumarket-react-design-system';
import { capitalize } from 'lodash';
import { useReadableDateTime } from '../../../hooks/useReadableDateTime';
import { useUnassignUsersFromLocations } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { useParams } from 'react-router';
import { LocationType } from 'app/types/User';
import './style.scss';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';

type Props = {
  location: LocationType;
  refetchLocations?: () => void;
};

export const LocationCardContent = ({
  // @ts-ignore - still not returning on the types in openApi
  location: { name, createdAt, key, usersCount },
  refetchLocations,
}: Props) => {
  const { isPermitted } = useAuthContext();
  const { key: userKey } = useParams<any>();
  const readableDateFormat = useReadableDateTime();
  const toaster = useToastContext();
  const unassignUserFromLocations = useUnassignUsersFromLocations();

  const handleUnassignUser = async () => {
    try {
      await unassignUserFromLocations({
        unassigning: [
          {
            locationKey: key!,
            userKey: userKey,
          },
        ],
      });
      refetchLocations?.();
    } catch (err) {
      toaster.error('Failed to unassign user');
    }
  };

  return (
    <div className="location-card">
      <div className="card-header">
        <span className="user-count">{usersCount}</span>
        <span>{capitalize(name)}</span>
      </div>
      <div className="card-body">
        <div className="card-body-details">
          <span>Created At</span>
          <p>{readableDateFormat(createdAt!, 'dd/LL/yyyy, h:mma')}</p>
        </div>
        {isPermitted('unassignUsersFromLocations') && (
          <Button onClick={handleUnassignUser}>
            <CrossIcon size="extra-small" fill="var(--tru-shuttle-grey)" />
          </Button>
        )}
      </div>
    </div>
  );
};
